<template>
  <div class="house-importer-finish-stage-restore-tariffs">
    <app-panel title="Восстановление начислений">
      <div slot="actions">
        <app-button @click="restoreTariffs" :disabled="isRestoring" color="success">{{isRestoring ? 'Восстанавливаю...' : 'Восстановить'}}</app-button>
      </div>


      <div class="house-importer-finish-stage-restore-tariffs__row">
        <app-datepicker label="Месяц"
                        v-model="month"
                        format="MMMM yyyy"
                        minimum-view="month"
        />
      </div>
<!--      <div class="house-importer-finish-stage-restore-tariffs__row"-->
<!--           v-for="(tariffName, index) in tariffsNames" :key="`row-${index}`">-->
<!--        <ChangeTariffsRow :tariffs="tariffs" :kvartalSelect="true" :kvartalTariffs="kvartalTariffs" class="" :value="tariffName" :tariffsNames="tariffsNames"-->
<!--                          @input="setTariffName($event, index)" @delete="deleteTariffName(index)"/>-->
<!--      </div>-->
<!--      <div class="house-importer-finish-stage-restore-tariffs__add-tariff">-->
<!--        <div class="house-importer-finish-stage-restore-tariffs__add-tariff-text link-icon"-->
<!--             @click="addTariffName">Добавить тариф-->
<!--        </div>-->
<!--      </div>-->
    </app-panel>
  </div>
</template>

<script>
  import ChangeTariffsRow from "../../import-charges-stage/components/ChangeTariffsRow";

  export default {
    name: "RestoreTariffs",
    components: {ChangeTariffsRow},
    props: {
      importInfo: {}
    },
    data(){
      return {
        tariffsNames: [],
        kvartalTariffs: [],
        tariffs: [],
        month: new Date(),
        isRestoring: false,
      }
    },
    methods: {
      async restoreTariffs(){
        this.isRestoring = true;
        try{
          let body = {
            import_id: this.importInfo.id,
            month: this.$options.filters.moment(this.month, 'YYYY-MM'),
            // elsa_tarifs: JSON.stringify(this.tariffsNames.map(v => v.elsa_name)),
            // kvartal_tarifs: JSON.stringify(this.tariffsNames.map(v => v.kvartal_name)),
          };

          let {data} = await this.$http.post('import/houses/restore_kvartal_charges', body);

          if(data === 'done'){
            this.$vs.notify({color: 'success', title: 'Тарифы восстановлены'});
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => {this.isRestoring = false}, 300);
        }
      },
      addTariffName() {
        let tariffName = {
          elsa_name: null,
          kvartal_name: null
        };
        this.tariffsNames.push(tariffName);
      },
      setTariffName(v, index) {
        this.$set(this.tariffsNames, index, v);
      },
      deleteTariffName(index) {
        this.tariffsNames.splice(index, 1);
      },
      async getTariffs() {
        try {
          let {data} = await this.$http.get('import/houses/tarifs', {params: {import_id: this.importInfo.id}});
          this.tariffs = data;
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.tariffs = []
        }
      },
      async getKvartalTariffs() {
        try {
          let {data} = await this.$http.get('import/houses/kvartal_tarifs', {params: {import_id: this.importInfo.id, month: this.$options.filters.moment(this.month, 'YYYY-MM')}});
          this.kvartalTariffs = data;
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.kvartalTariffs = []
        }
      }
    },
    created() {
      // this.getTariffs();
      // this.getKvartalTariffs();
    },
    watch:{
      month(){
        // this.getKvartalTariffs();
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-finish-stage-restore-tariffs{

    &__row{
      margin-bottom: 15px;
    }

    &__add-tariff {
      margin-bottom: 15px;
      text-align: center;

      &-text {
        display: inline-block;
        font-size: 12px;
      }
    }

  }

</style>
